import Input from '@/components/Common/Input';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { RiDeleteBin6Line } from 'react-icons/ri';

export default function SpamConfig() {
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'spam_call_termination_details.patterns'
  });

  return (
    <Paper variant='outlined' sx={{ p: 3 }}>
      <Typography fontWeight={600} mb={2}>
        Spam Call Settings
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          backgroundColor: '#F5F5F5',
          borderRadius: '4px',
          padding: '12px 16px'
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#F57C00', // orange tone
            fontSize: '20px'
          }}
        >
          <IoIosInformationCircleOutline />
        </Box>

        {/* Text */}
        <Typography
          sx={{
            fontSize: '14px',
            color: '#616161',
            lineHeight: 1.5
          }}
        >
          The agent will politely end the conversation when spam intent is detected
        </Typography>
      </Box>

      {fields.map((f, index) => (
        <Box key={f.id} display='flex' gap={2} alignItems='center' mt={2}>
          <Input
            name={`spam_call_termination_details.patterns.${index}.value`} // ✅ BE KEY
            control={control}
            label='Spam Pattern'
            placeholder='e.g. lottery, win money'
            fullWidth
          />

          <IconButton onClick={() => remove(index)}>
            <RiDeleteBin6Line color='#D32F2F' />
          </IconButton>
        </Box>
      ))}

      {/* ADD PATTERN */}
      <Button variant='outlined' sx={{ borderRadius: 20, mt: 2 }} onClick={() => append({ value: '' })}>
        + Add Pattern
      </Button>
    </Paper>
  );
}
